import callCmAPI from 'services/helpers/call-cm-api'
import { BannerT, UpdateBannerDataT, WebApi2Response } from 'types/global'

export type UpdateBannerArgs = {
  id: string
  body: UpdateBannerDataT
}

/**
 * Updates an existing banner.
 *
 * The patch shape mirrors create — CMAPI re-validates the merged
 * row, so passing only the changed fields is enough. `created_by`
 * is immutable on the server.
 */
export const updateBanner = ({
  id,
  body,
}: UpdateBannerArgs): Promise<WebApi2Response<BannerT>> =>
  callCmAPI(`/banner/${id}`, {
    method: 'put',
    data: body,
  }).then(({ data }) => {
    return data
  })
